import { Box } from '@domain-group/suit-theme'

interface ColouredCircleProps {
  backgroundColor?: string,
}

const ColouredCircle = (props: ColouredCircleProps) => {
  const { backgroundColor } = props

  return (
    <Box
      backgroundColor={backgroundColor}
      border="1px solid"
      borderColor="lineColor"
      borderRadius="50%"
      flexShrink={0}
      height={16}
      width={16}
    />
  )
}

export default ColouredCircle
